export { default as SketchFabPlayer } from './SketchFabPlayer';
